(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sp-customer-calls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sp-customer-calls')) {
  customElements.define('sp-customer-calls', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('.sh-calls__track');
      const arrows = [...this.querySelectorAll('[data-direction]')];
      const update = () => {
        arrows[0].disabled = track.scrollLeft <= 2;
        arrows[1].disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      arrows.forEach(button => button.addEventListener('click', () => {
        const distance = track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({ left: distance * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }));
      track.addEventListener('scroll', update, { passive:true });
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(track);
      this.visibilityObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) entry.target.querySelector('video')?.pause();
      }), { threshold:0.5 });
      this.querySelectorAll('.sh-calls__card').forEach(card => this.visibilityObserver.observe(card));
      this.querySelectorAll('.sh-calls__play').forEach(button => button.addEventListener('click', () => {
        const media = button.parentElement;
        let video = media.querySelector('video');
        if (!video) {
          media.append(media.querySelector('template').content.cloneNode(true));
          video = media.querySelector('video');
          video.addEventListener('play', () => document.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); }));
        }
        video.muted = false;
        button.hidden = true;
        video.focus();
        video.play().catch(() => { button.hidden = false; });
      }));
      update();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sp-nutrition-modal"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialized = new WeakSet();
  function initializeNutrition(root) {
    root.querySelectorAll('dialog.sh-nutrition').forEach((dialog) => {
      if (initialized.has(dialog)) return;
      initialized.add(dialog);
      if (typeof dialog.showModal !== 'function') return;
      const section = dialog.closest('.sh-pathways');
      const trigger = section?.querySelector('[data-nutrition-open]');
      if (!trigger) return;
      let previousOverflow;
      let opener;
      let pointerStartedOutside = false;
      const outside = (event) => {
        const bounds = dialog.getBoundingClientRect();
        return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
      };
      trigger.hidden = false;
      trigger.addEventListener('click', () => {
        if (dialog.open) return;
        opener = document.activeElement;
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        dialog.querySelector('.sh-nutrition__body').scrollTop = 0;
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow;
        if (opener?.isConnected) opener.focus({ preventScroll: true });
      });
      dialog.addEventListener('pointerdown', (event) => { pointerStartedOutside = event.target === dialog && outside(event); });
      dialog.addEventListener('click', (event) => {
        if (pointerStartedOutside && event.target === dialog && outside(event)) dialog.close();
        pointerStartedOutside = false;
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeNutrition(document), { once: true });
  } else initializeNutrition(document);
  document.addEventListener('shopify:section:load', (event) => initializeNutrition(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('dialog.sh-nutrition[open]').forEach((dialog) => dialog.close());
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sp-research-results"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialized = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initializeCounts(root) {
    root.querySelectorAll('.sh-research__stats').forEach(stats => {
      if (initialized.has(stats)) return;
      initialized.add(stats);
      const counters = [...stats.querySelectorAll('dd')].map(element => {
        const original = element.textContent.trim();
        const match = original.match(/^(\D*)(\d+(?:\.\d+)?)(.*)$/);
        if (!match) return null;
        element.setAttribute('aria-label', original);
        return { element, original, prefix: match[1], target: Number(match[2]), suffix: match[3], decimals: (match[2].split('.')[1] || '').length };
      }).filter(Boolean);
      if (!counters.length || reducedMotion.matches || !('IntersectionObserver' in window)) return;
      stats.dataset.countState = 'waiting';
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.3)) return;
        observer.disconnect();
        if (reducedMotion.matches) return;
        stats.dataset.countState = 'running';
        const startedAt = performance.now();
        counters.forEach(counter => { counter.element.textContent = counter.prefix + (0).toFixed(counter.decimals) + counter.suffix; });
        function tick(now) {
          if (!stats.isConnected) return;
          const progress = reducedMotion.matches ? 1 : Math.min(1, (now - startedAt) / 650);
          const eased = 1 - Math.pow(1 - progress, 3);
          counters.forEach(counter => {
            counter.element.textContent = progress === 1 ? counter.original : counter.prefix + (counter.target * eased).toFixed(counter.decimals) + counter.suffix;
          });
          if (progress < 1) requestAnimationFrame(tick);
          else stats.dataset.countState = 'complete';
        }
        requestAnimationFrame(tick);
      }, { threshold: 0.3, rootMargin: '0px 0px -60px 0px' });
      observer.observe(stats);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeCounts(document), { once: true });
  else initializeCounts(document);
  document.addEventListener('shopify:section:load', event => initializeCounts(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sp-skin-pathways"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialized = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initializeCounts(root) {
    root.querySelectorAll('.sh-pathways__stats').forEach((stats) => {
      if (initialized.has(stats)) return;
      initialized.add(stats);
      if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        if (reducedMotion.matches) return;

        const counters = [...stats.querySelectorAll('[data-count-to]')];
        const targets = counters.map((counter) => Number(counter.dataset.countTo));
        const startedAt = performance.now();
        const duration = 780;
        const stagger = 85;
        const animations = [];

        counters.forEach((counter, index) => {
          counter.textContent = '00';
          if (typeof counter.animate === 'function') {
            animations.push(counter.animate(
              [{ opacity: 0.35, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }],
              { duration: 500, delay: index * stagger, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'backwards' }
            ));
          }
        });

        function tick(now) {
          if (!stats.isConnected) {
            animations.forEach((animation) => animation.cancel());
            return;
          }
          const stopMotion = reducedMotion.matches;
          if (stopMotion) animations.forEach((animation) => animation.cancel());
          let complete = true;
          counters.forEach((counter, index) => {
            const progress = stopMotion ? 1 : Math.min(1, Math.max(0, (now - startedAt - index * stagger) / duration));
            const eased = 1 - Math.pow(1 - progress, 3);
            const value = progress === 1 ? targets[index] : Math.floor(targets[index] * eased);
            const text = String(value).padStart(2, '0');
            if (counter.textContent !== text) counter.textContent = text;
            if (progress < 1) complete = false;
          });
          if (!complete) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }, { threshold: 0.65, rootMargin: '0px 0px -100px 0px' });
      observer.observe(stats);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCounts(document), { once: true });
  } else {
    initializeCounts(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeCounts(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
